/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { RequiredMark, StyledErrorText, StyledLabel } from './styled';
import type { ErrorTextProps, LabelProps } from './types';

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  (
    {
      weight = 'bold',
      required = false,
      children,
      className,
      testId = 'label',
      css,
      style,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledLabel
        ref={ref}
        $weight={weight}
        className={className}
        css={css}
        style={style}
        data-testid={testId}
        data-weight={weight}
        {...rest}
      >
        {children}
        {required ? <RequiredMark aria-hidden>*</RequiredMark> : null}
      </StyledLabel>
    );
  }
);

Label.displayName = 'Label';

export function ErrorText({
  children,
  size = 'md',
  className,
  testId = 'error-text',
  css,
  style,
  role = 'alert',
  id,
}: ErrorTextProps) {
  return (
    <StyledErrorText
      $size={size}
      className={className}
      css={css}
      style={style}
      data-testid={testId}
      role={role}
      id={id}
    >
      {children}
    </StyledErrorText>
  );
}
